import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { CardTitle } from '@/components/ui/card';
    import { columns } from '@/tables/columns/employees';
    import { computed } from 'vue';
    import { handleQueryRetry } from '@/utils/helpers';
    import { Head } from '@inertiajs/vue3';
    import { usePage } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import { useUrlSearch } from '@/composables/useUrlSearch';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import CreateEmployee from '@/components/employees/CreateEmployee.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import ExportEmployeesChanges from '@/components/employees/ExportEmployeesChanges.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { SharedData, BreadcrumbItem } from '@/types';
    import UploadEmployees from '@/components/employees/UploadEmployee.vue';
    import UploadEmployeesAdmin from '@/components/employees/UploadEmployeeAdmin.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Employees',
  setup(__props) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);
    const isClient = computed(() => page.props.auth.user.is_client);
    const canAccessSalary = computed(() => page.props.auth.user.can_access_salary);

    const { hasPermission } = usePermissions();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.administration',
        },
        {
            title: 'employee.page_header',
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.EMPLOYEES, selectedCompanyId],
        queryFn: getEmployees,
        retry: handleQueryRetry,
        enabled: computed(() => !!page.props.auth.user.selected_company_id),
    });

    const { extractAndCleanSearch } = useUrlSearch();
    const initialSearch = extractAndCleanSearch();

    async function getEmployees() {
        const { data } = await axios.get(route('v2.salary.employees.table'), {
            params: {
                search: initialSearch || undefined,
            },
        });
        return data.data;
    }

    const showChangesColumn = computed(() => !(isClient.value && !canAccessSalary.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('employee.page_header')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, {
      breadcrumbs: breadcrumbs,
      "require-selected-company": ""
    }, {
      default: _withCtx(() => [
        _createVNode(PageCard, null, {
          default: _withCtx(() => [
            _createVNode(DataTable, {
              "table-key": _unref(QueryKey).EMPLOYEES,
              columns: _unref(columns),
              data: _unref(data),
              loading: _unref(isPending),
              "auto-url-search": true,
              "default-column-visibility": {
                    company_id: false,
                    changes: showChangesColumn.value,
                    actions: _unref(hasPermission)(_unref(Permission).EMPLOYEES_UPDATE),
                },
              "default-sorting": [
                    {
                        id: 'full_name',
                        desc: false,
                    },
                ]
            }, {
              title: _withCtx(() => [
                _createVNode(_unref(CardTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('employee.page_header')), 1)
                  ]),
                  _: 1
                })
              ]),
              actions: _withCtx(() => [
                _createVNode(DataTableToolbarActions, { name: "employees" }, {
                  default: _withCtx(() => [
                    (_unref(hasPermission)(_unref(Permission).EMPLOYEES_CREATE))
                      ? (_openBlock(), _createBlock(CreateEmployee, { key: 0 }))
                      : _createCommentVNode("", true),
                    (_unref(hasPermission)(_unref(Permission).EMPLOYEES_IMPORT_CREATE))
                      ? (_openBlock(), _createBlock(UploadEmployees, { key: 1 }))
                      : _createCommentVNode("", true),
                    (_unref(hasPermission)(_unref(Permission).EMPLOYEES_ADMIN_IMPORT_CREATE))
                      ? (_openBlock(), _createBlock(UploadEmployeesAdmin, { key: 2 }))
                      : _createCommentVNode("", true),
                    (_unref(hasPermission)(_unref(Permission).EMPLOYEES_VIEW))
                      ? (_openBlock(), _createBlock(ExportEmployeesChanges, { key: 3 }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["table-key", "columns", "data", "loading", "default-column-visibility"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})